import * as React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import FontAwesome from 'react-native-vector-icons/FontAwesome';
import { NavigationInjectedProps, withNavigation } from 'react-navigation';
import { translate } from 'secullum-i18n';
import {
  Button,
  Modal,
  Space,
  getTheme,
  isTablet
} from 'secullum-react-native-ui';
import { Subscribe } from 'unstated';
import { FuncionarioContainer } from '../../shared/containers/FuncionarioContainer';
import { Telas } from '../../shared/modules/telas';
import { TipoPlano } from '../../shared/modules/types';

interface Props {
  mensagem: string;
  onFechar: () => void;
  onTentarNovamente: (() => void) | null;
}

class MensagemErroConexao extends React.Component<
  Props & NavigationInjectedProps
> {
  handleTentarNovamente = () => {
    this.props.onFechar();

    if (this.props.onTentarNovamente) {
      this.props.onTentarNovamente();
    }
  };

  handleRegistrarPontoOffline = () => {
    this.props.onFechar();
    this.props.navigation.navigate(Telas.IncluirPonto, { forcarOffline: true });
  };

  getStyles = () => {
    const theme = getTheme();

    return StyleSheet.create({
      overlay: {
        alignItems: 'center'
      },
      container: {
        backgroundColor: theme.backgroundColor1,
        borderRadius: 6,
        padding: isTablet() ? 25 : 16,
        width: isTablet() ? 350 : 250,
        marginTop: isTablet() ? 250 : 140,
        alignItems: 'center'
      },
      text: {
        color: theme.textColor1,
        fontSize: isTablet() ? 25 : 16,
        textAlign: 'center',
        marginTop: isTablet() ? 15 : 5,
        width: '100%'
      },
      tentarNovamente: {
        width: '100%'
      },
      registrarOffline: {
        width: '100%'
      }
    });
  };

  render() {
    const styles = this.getStyles();
    const theme = getTheme();

    return (
      <Modal
        visible={this.props.mensagem !== ''}
        onRequestClose={this.props.onFechar}
        overlayStyle={styles.overlay}
      >
        <View style={styles.container}>
          <FontAwesome
            name="warning"
            color={theme.warningColor}
            size={isTablet() ? 52 : 42}
          />
          <Text style={styles.text}>{this.props.mensagem}</Text>
          <Subscribe to={[FuncionarioContainer]}>
            {(funcionario: FuncionarioContainer) => {
              const { dados } = funcionario.state;
              const { permitirInclusaoPontoOffline } =
                dados.configuracoesIncluirPontoOffline;

              if (
                dados.plano > TipoPlano.Basic &&
                permitirInclusaoPontoOffline
              ) {
                return (
                  <>
                    <Space />
                    <Button
                      nativeID="botao-registrar-ponto-offline-modal"
                      text={translate('Registrar ponto offline')}
                      onPress={this.handleRegistrarPontoOffline}
                      style={styles.registrarOffline}
                    />
                  </>
                );
              }

              return null;
            }}
          </Subscribe>
          <Space />
          <Button
            nativeID="botao-tentar-novamente-modal"
            text={translate('Tentar Novamente')}
            onPress={this.handleTentarNovamente}
            style={styles.tentarNovamente}
          />
        </View>
      </Modal>
    );
  }
}

export default withNavigation(MensagemErroConexao);
